<template>
  <section v-if="isAdmin" class="auth-form">
    <div class="auth-form__container">
      <AuthenticationBackground />
      <div v-show="!isLoading" class="auth-form__wrapper">
        <div class="auth-form__forms">
          <ManageImpersonationForm
            v-if="currentMode === 'impersonate-user'"
            class="auth-form__form"
            @handle-loading="handleLoading"
            :isImpersonating="isImpersonating"
            :profile="profile"
          />
          <ManageSuspensionForm
            v-if="currentMode === 'manage-user-suspension'"
            class="auth-form__form"
            @handle-loading="handleLoading"
          />
          <ManagePasswordForm
            v-if="currentMode === 'manage-user-password'"
            class="auth-form__form"
            @handle-loading="handleLoading"
            :newPassword="newPassword"
          />
          <ManageConfirmationForm
            v-if="currentMode === 'manage-user-confirmation'"
            class="auth-form__form"
            @handle-loading="handleLoading"
          />
        </div>
        <AdditionalLinks
          :isTabletFooter="true"
          class="auth-form__form-footer-links"
        />
      </div>
      <Spinner
        v-show="isLoading"
        class="auth-form__wrapper auth-form__spinner"
      />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import AuthenticationBackground from '@/components/forms/elements/AuthenticationBackground.vue'
import ManageConfirmationForm from '@/components/forms/admin/ManageConfirmationForm.vue'
import ManageImpersonationForm from '@/components/forms/admin/ManageImpersonationForm.vue'
import ManagePasswordForm from '@/components/forms/admin/ManagePasswordForm.vue'
import ManageSuspensionForm from '@/components/forms/admin/ManageSuspensionForm.vue'
import Spinner from '@/components/loaders/LoadingSpinnerV2.vue'
import AdditionalLinks from '@/components/forms/elements/AdditionalLinks.vue'

export default {
  name: 'Admin',
  components: {
    AuthenticationBackground,
    ManageConfirmationForm,
    ManageImpersonationForm,
    ManagePasswordForm,
    ManageSuspensionForm,
    AdditionalLinks,
    Spinner,
  },
  metaInfo() {
    return {
      title: 'INE - Admin',
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  data() {
    return {
      currentEmailValid: false,
      passwordValid: false,
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      isAdmin: state => state.auth.isAdmin,
      isImpersonating: state => state.admin.isImpersonating,
      profile: state => state.auth.userProfile,
      newPassword: state => state.admin.usersNewPassword,
    }),
    currentMode() {
      return this.$route.params.mode
    },
  },
  methods: {
    handleLoading(value) {
      this.isLoading = value
    },
  },
  created() {
    if (!this.isAdmin) {
      this.$router.push({ name: 'home' })
    }
  },
}
</script>
